import { BusinessSchema } from '@40seas/entities/businesses';
import { Buyer } from '@40seas/entities/buyers';
import { Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';

export const AirwallexCustomerSchema = WithBaseEntitySchema(
    z.object({
        buyer: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .or(BusinessSchema),
        providerId: z.string(),
    }),
).strict();

export class AirwallexCustomer extends FromSchema(AirwallexCustomerSchema) implements BaseEntity {
    id: string;
    buyer: string | Buyer;
    providerId: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    tenantId: string;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
